module.exports = __webpack_public_path__ + "assets/img/b2f19a28f64dba6d19d5343356530103.webp";